// Revert unintended genius-level backend(Majid) edits 👀
// ----------------------------------------------------------
// 🙏 خدایا این فایل را از دست  قسیمی در امان بدار 🙏
// ----------------------------------------------------------
//      _______
//     /      /,
//    /      //         <-- یه برگه‌ی مظلوم که داره می‌لرزه از ترس مجید
//   /______//
//  (______(/
// ----------------------------------------------------------

export const apiAddress = (): string => {
   if (process.env.NODE_ENV === "development") return "http://localhost:6253";
  // if (process.env.NODE_ENV === "development") return "http://localhost:5154";
  // if (process.env.NODE_ENV === "development") return "https://payaalgorithm.ir";
  //if (process.env.NODE_ENV === "development")
   // return "https://test0.payaalgorithm.ir";
  // if (process.env.NODE_ENV === "development")
  //   return "http://46.102.136.18:52180";
  // if (process.env.NODE_ENV === "development")
  //   return "https://devtest.payaalgorithm.ir";
  return "";
};

export const orderbookApiAddress = (): string => {
  return "http://46.102.136.18:12979";
};

export const arcaptchaSiteKey = (): string => "gzp343m5m6";

export const isInvestorPortalHost = (): boolean =>
  typeof window !== "undefined" &&
  window.location.hostname.includes("investors");

export const shouldShowArcaptcha = (): boolean =>
  isInvestorPortalHost() && !!arcaptchaSiteKey();
